import {defineStore} from "pinia";
import {useRegistrationStore} from "@/stores/registration.ts";
import {computed} from "vue";
import {ORIGINS} from "@/services/ConstantSerice.ts";

export const useConfigStore = defineStore('config', () => {
    const registrationStore = useRegistrationStore();
    
    const baseUrl = import.meta.env.VITE_API_BASE_URL;
    const googleApiKey = import.meta.env.VITE_GOOGLE_API_KEY;
    const dashboardUrl = import.meta.env.VITE_DASHBOARD_URL ?? 'https://dashboard.fixr.com'
    
    const supportPhone = computed(() => {
        if (registrationStore.registrationOrigin?.toLocaleLowerCase() === ORIGINS.HM) {
            return import.meta.env.VITE_SUPPORT_PHONE_HOWMUCH;
        }
        
        return import.meta.env.VITE_SUPPORT_PHONE;
    })
    
    const supportEmail = computed(() => {
        if (registrationStore.registrationOrigin?.toLocaleLowerCase() === ORIGINS.HM) {
            return import.meta.env.VITE_SUPPORT_EMAIL_HOWMUCH;
        }

        return import.meta.env.VITE_SUPPORT_EMAIL;
    });

    return {
        baseUrl,
        googleApiKey,
        supportPhone,
        supportEmail,
        dashboardUrl
    }
});